<template>
  <div class="addBankCard-page">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('新增银行卡') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <div class="usrse">
        <div class="hgs">
          <div class="nams">持卡人姓名</div>
          <div>
            <div data-v-a12ec382="" class="van-cell-group van-hairline--top-bottom">
              <div data-v-a12ec382="" class="van-cell van-field">
                <div class="van-cell__value van-cell__value--alone van-field__value">
                  <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_owner" placeholder="请输入持卡人姓名" class="van-field__control" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="font-size: 0.26rem; color: #98a5b3; text-align: center; box-sizing: border-box; padding: 6px">为了您的资金能够迅速到账，请确保填写的姓名与银行卡的开户姓名一致</div>
      <div class="usrse">
        <div class="hgs" @click="changShow">
          <div class="nams">{{ $t('银行类型') }}</div>
          <div class="input-box readonly">
            <input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank" disabled placeholder="请选择银行类型" class="van-field__control" />
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('银行卡号') }}</div>
          <div>
            <div data-v-a12ec382="" class="van-cell-group van-hairline--top-bottom">
              <div data-v-a12ec382="" class="van-cell van-field">
                <div class="van-cell__value van-cell__value--alone van-field__value">
                  <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_no" :placeholder="$t('请输入银行卡号')" class="van-field__control" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('开户行') }}</div>
          <div >
            <div data-v-a12ec382="" class="van-cell-group van-hairline--top-bottom">
              <div data-v-a12ec382="" class="van-cell van-field">
                <div class="van-cell__value van-cell__value--alone van-field__value">
                  <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_address" placeholder="请输入开户行" class="van-field__control" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $t('支付密码') }}</div>
          <div class="input-box">
            <input v-model="cardInfo.pay_pass" type="password" :placeholder="$t('请输入支付密码')">
          </div>
        </div>
        <div class="submit-btn" @click="bindCard">{{ $t('确认添加') }}</div>
      </div>
    </div>
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" :title="$t('银行类型')" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'addBankCard',
  data() {
    return {
      cardInfo: {},
      banklist: [],
      show: false,
    };
  },
  created() {
    let that = this;
    that.getBanklist();
  },
  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.cardInfo.bank = value.bank_name;
      console.log(this.cardInfo.bank);
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    getBanklist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.showTost(0, '请输入姓名');
        return;
      }
      if (!that.cardInfo.bank) {
        that.showTost(0, '请输入银行');
        return;
      }
      if (!that.cardInfo.bank_address) {
        that.showTost(0, that.$t('请输入开户行地址'));
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.showTost(0, '请输人银行卡号');
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.showTost(0, '请输人支付密码');
        return;
      }
      if (that.cardInfo.bank_no.length < 8) {
        that.showTost(0, '请输人正确的卡号长度');
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.showTost(0, '请输人支付密码长度');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(async (res) => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, '绑定成功');
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.addBankCard-page {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: 0 .4rem;
    .usrse {
      box-sizing: border-box;
      .hgs {
        margin-top: .27rem;
        border-radius: .19rem;
        background: rgba(255, 255, 255, 0.10);
        border: 0.03rem solid rgba(255, 255, 255, 0.10);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .27rem;
        height: 1.49rem;
      }
      .nams {
        font-size: 0.37rem;
        font-weight: bold;
        vertical-align: middle;
      }
      .input-box {
        width: 50%;
        height: 100%;
        position: relative;
        &.readonly::after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        input {
          width: 100%;
          height: 100%;
          background: transparent;
          outline: none;
          border: none;
          color: #fff;
          &::placeholder {
            color: #bbb;
          }
        }
      }
    }
    input {
      text-align: right !important;
      color: #fff;
    }
    .submit-btn {
      width: 100%;
      height: 1.23rem;
      border-radius: .6rem;
      margin-top: .53rem;
      background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.43rem;
      font-weight: 600;
    }
  }
  .van-cell-group {
    background: transparent;
  }
  .van-cell {
    background: transparent;
    padding: .3rem 0 !important;
  }

  [class*=van-hairline]:after {
    display: none !important;
  }
  .van-field__control {
    text-align: right !important;
  }
  .van-picker__columns {
    color: #000;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    box-shadow: 0 0 0px 1000px transparent inset !important;
    -webkit-text-fill-color: #fff !important; /* 保持文本颜色继承 */
    transition: background-color 9999s ease-out 0s !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/addBankCard.vue